import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@livingsecurity/shared';
import { ChatLayout, ChatConversation } from './components';
import useIntegrations from './api/hooks/useIntegrations';

import * as Styled from './styles';

const Chatbot = (props) => {
  const { t } = useTranslation(['shared']);
  const { user, loading, isUserHasRights, isImpersonate } = useAuth0();
  const { integrations } = useIntegrations(user?.tenant_id, isUserHasRights, isImpersonate);

  if (!user || loading) return null;

  return (
    <Styled.Wrapper id="chatbot" className="dark" data-theme="dark">
      <ChatLayout>
        <ChatConversation user={user} integrations={integrations} {...props} />
      </ChatLayout>
    </Styled.Wrapper>
  );
};

Chatbot.propTypes = {};

export default Chatbot;
